import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=348745f8"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348745f8')) {
      api.createRecord('348745f8', component.options)
    } else {
      api.reload('348745f8', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=348745f8", function () {
      api.rerender('348745f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/Settings.vue"
export default component.exports